import { accrualMonetaryAmountSchema } from "@common/dto/financialDocument/accrual-document-extraction.schema";
import { roundToCents } from "./monetary";

export function computeAccrualLineAmount(params: {
    quantity: number | null | undefined;
    unitPrice: number | null | undefined;
    amount: number;
}): number;
export function computeAccrualLineAmount(params: {
    quantity: number | null | undefined;
    unitPrice: number | null | undefined;
    amount: number | null | undefined;
}): number | null;
export function computeAccrualLineAmount({
    quantity,
    unitPrice,
    amount,
}: {
    quantity: number | null | undefined;
    unitPrice: number | null | undefined;
    amount: number | null | undefined;
}): number | null {
    if (quantity != null && unitPrice != null) {
        const derivedAmount = roundToCents(quantity * unitPrice);
        if (accrualMonetaryAmountSchema.safeParse(derivedAmount).success) {
            return derivedAmount;
        }
    }

    return amount ?? null;
}
